import { FunnelMapPutPayload } from './useFunnelMapApiFacade';

// Convert FunnelMap to FunnelMapPutPayload
export const funnelMapToFunnelMapPutPayload = (
  funnelMap: Pick<
    FunnelMap,
    | 'name'
    | 'funnels'
    | 'thirdPartyFunnels'
    | 'metadataElements'
    | 'name'
    | 'sections'
    | 'stickyNotes'
    | 'texts'
  >,
  version: number,
): FunnelMapPutPayload => {
  const funnelsArray: FunnelMapPutPayload['funnels'] = Object.entries(funnelMap.funnels).map(
    ([funnelId, funnel]) => ({
      funnelId,
      ...funnel.position,
      sectionId: funnel.sectionId || null,
    }),
  );

  const thirdPartyFunnelsArray: FunnelMapPutPayload['thirdPartyFunnels'] = Object.entries(
    funnelMap.thirdPartyFunnels,
  ).map(([thirdPartyFunnelId, thirdPartyFunnel]) => ({
    thirdPartyFunnelId,
    ...thirdPartyFunnel.position,
    sectionId: thirdPartyFunnel.sectionId || null,
  }));

  const metadataElementsArray: FunnelMapPutPayload['metadataElements'] = Object.values(
    funnelMap.metadataElements || {},
  ).map((metadataElement) => ({
    metadataId: metadataElement.metadataId,
    ...metadataElement.position,
    color: metadataElement.color,
    icon: metadataElement.icon,
    funnelLinks: metadataElement.funnelLinks,
    crmOrgId: metadataElement.crmOrgId,
    sectionId: metadataElement.sectionId || null,
  }));
  const sectionsArray: FunnelMapPutPayload['sections'] = Object.values(
    funnelMap.sections || {},
  ).map((section) => ({
    sectionId: section.sectionId,
    xyPosition: section.xyPosition,
    width: section.width,
    height: section.height,
    backgroundColor: section.backgroundColor,
    name: section.name,
  }));

  const stickyNotesArray: FunnelMapPutPayload['stickyNotes'] = Object.values(
    funnelMap.stickyNotes || {},
  ).map((stickyNote) => ({
    stickyNoteId: stickyNote.stickyNoteId,
    xyPosition: stickyNote.xyPosition,
    width: stickyNote.width,
    height: stickyNote.height,
    backgroundColor: stickyNote.backgroundColor,
    richText: stickyNote.richText,
    sectionId: stickyNote.sectionId || null,
  }));

  const textNodesArray: FunnelMapPutPayload['texts'] = Object.values(funnelMap.texts || {}).map(
    (textNode) => ({
      textId: textNode.textId,
      xyPosition: textNode.xyPosition,
      width: textNode.width,
      height: textNode.height,
      sectionId: textNode.sectionId || null,
      richText: textNode.richText,
    }),
  );

  return {
    funnels: funnelsArray,
    name: funnelMap.name,
    recordTypes: [],
    hubspotFunnels: [],
    thirdPartyFunnels: thirdPartyFunnelsArray,
    metadataElements: metadataElementsArray,
    version,
    sections: sectionsArray,
    stickyNotes: stickyNotesArray,
    texts: textNodesArray,
  };
};
